/**
 * Map setup add/edit access fieldErrors onto AddTemplateDialog error keys.
 * Server already emits assignment_* keys; normalize array/string values.
 * @param {Record<string, string|string[]>|null|undefined} fieldErrors
 * @returns {Record<string, string>}
 */
export function accessErrorsToFieldErrors(fieldErrors = {}) {
  const out = {};
  Object.entries(fieldErrors || {}).forEach(([key, value]) => {
    if (value == null || value === '') return;
    if (Array.isArray(value)) {
      const msg = value.filter(Boolean).join('; ');
      if (msg) out[key] = msg;
      return;
    }
    out[key] = String(value);
  });
  return out;
}

/**
 * fieldErrors from checklist add/edit. Accepts the axios error or a thrown
 * envelope whose response is the axios response.
 * @param {Error|null|undefined} err
 * @returns {Record<string, string|string[]>|null}
 */
export function readTemplateSaveFieldErrors(err) {
  const body = err?.response?.data;
  const nested = body?.data;
  const payload =
    nested && typeof nested === 'object' && !Array.isArray(nested) ? nested : body || {};
  const fieldErrors = payload.fieldErrors || body?.fieldErrors || err?.fieldErrors || null;
  if (!fieldErrors || typeof fieldErrors !== 'object' || Array.isArray(fieldErrors)) return null;
  if (!Object.keys(fieldErrors).length) return null;
  return fieldErrors;
}
